import DataService from "@/core/base/service/data.service";
import { ILogEntry } from "@/shared/model/log-entry.model";

export default class LogEntryService extends DataService<ILogEntry> {
  protected baseApiUrl: string = "api/log-entries";
}
